/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubMenu } from '../../models/sub-menu';

export interface ApiMasterSubMenuGetAllGet$Params {
}

export function apiMasterSubMenuGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterSubMenuGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubMenu>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterSubMenuGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubMenu>>;
    })
  );
}

apiMasterSubMenuGetAllGet.PATH = '/api/Master/SubMenu/GetAll';
